module.exports = __webpack_public_path__ + "img/11.d701dd2b.jpg";